import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c03a8d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = { class: "menu-text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("LP Wizard ")
const _hoisted_4 = { class: "vcs_ref" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Сайт")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Стиль")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Координаты")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Аналитика")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Блоки")
const _hoisted_10 = { class: "reset" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Сброс")
const _hoisted_12 = { class: "logout" }
const _hoisted_13 = { class: "main grid-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _withDirectives(_createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.vcsRef), 1)
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "dashicons:admin-site",
                inline: true
              }),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/style" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "fluent:paint-brush-24-filled",
                inline: true
              }),
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/contacts" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "bi:pin-map-fill",
                inline: true
              }),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/analytics" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "fluent:target-arrow-20-filled",
                inline: true
              }),
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: "/blocks" }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                icon: "gg:website",
                inline: true
              }),
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, [
            _createVNode(_component_Icon, {
              icon: "healthicons:death-alt",
              inline: "true"
            }),
            _hoisted_11
          ])
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, "Выход")
        ])
      ], 512), [
        [_vShow, _ctx.$auth.check()]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}